import {Injectable} from "@angular/core";
import {ApiService} from "../../services/api.service";
import {ChangeTermsPurchase} from "./change-terms-purchase";

@Injectable()
export class ChangeTermsPurchaseService {

    public constructor(private api: ApiService) {}

    public update(data: ChangeTermsPurchase) {
        return this.api.get('purchase/change-terms', data)
    }

    public getProcedure(data: {}) {
        return this.api.get('purchase/get-procedure', data)
    }

    // public getProcedure(purchaseNumber: string) {
    //     return this.api.post('purchase/get-procedure', purchaseNumber)
    // }
}


// WEBPACK FOOTER //
// ./src/app/pages/change-terms-purchase/change-terms-purchase.service.ts